import React from 'react'
import PropTypes from 'prop-types'

import Portal from 'common/builder/components/chart/FlowChart/nodes/shared/portals/Portal'
import { Colors } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

import Arrow from './Arrow'

export default class ArrowWrapper extends React.Component {
  static propTypes = {
    color: PropTypes.string.isRequired,
    interactive: PropTypes.bool,
    isHover: PropTypes.bool,
    name: PropTypes.string,
    offsetX: PropTypes.number,
    onClick: PropTypes.func.isRequired,
    onDoubleClick: PropTypes.func.isRequired,
    onMouseOut: PropTypes.func.isRequired,
    onMouseOver: PropTypes.func.isRequired,
    onTap: PropTypes.func.isRequired,
    position: PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.props.position.on('update', this.update)
  }

  componentDidUpdate() {
    this.renderArrow(this.arrow)
  }

  componentWillUnmount() {
    this.props.position.removeListener('update', this.update)
  }

  update = () => {
    this.renderArrow(this.arrow)
  }

  renderArrow = (arrow) => {
    if (!arrow) {
      return
    }
    const { position, offsetX } = this.props
    const { x1, y1, x2, y2, width, arrowVisible } = position
    arrow.renderGraphics(x1 + offsetX, y1, x2, y2, width, arrowVisible)
  }

  handleArrowRef = (el) => {
    this.arrow = el
    this.update()
  }

  handleHoverArrowRef = (el) => {
    if (el) {
      this.renderArrow(el)
    }
  }

  render() {
    const { color, position, interactive, isHover, name } = this.props
    const { onClick, onDoubleClick, onMouseOver, onMouseOut, onTap } = this.props

    const arrowColor = color.replace('#', '0x') * 1

    return (
      <>
        <Portal to={'background'}>
          <Arrow
            ref={this.handleArrowRef}
            color={arrowColor}
            position={position}
            interactive={interactive}
            name={name}
            onClick={onClick}
            onDoubleClick={onDoubleClick}
            onMouseOut={onMouseOut}
            onMouseOver={onMouseOver}
            onTap={onTap}
          />
        </Portal>
        {isHover && (
          <Portal to={'foreground'}>
            <Arrow ref={this.handleHoverArrowRef} color={Colors.PRIMARY.replace('#', '0x') * 1} />
          </Portal>
        )}
      </>
    )
  }
}
